"use client";

import { SearchX } from "lucide-react";
import Link from "next/link";
import { Typography } from "@/components/common/ui/Typography";

export interface FeatureNotFoundProps {
  title: string;
  description: string;
  backLink: {
    href: string;
    label: string;
  };
}

export function FeatureNotFound({
  title,
  description,
  backLink,
}: FeatureNotFoundProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] p-6">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 bg-navigator-accent-light rounded-2xl flex items-center justify-center mx-auto mb-4">
          <SearchX
            className="w-8 h-8 text-navigator-primary"
            strokeWidth={1.5}
          />
        </div>
        <Typography variant="headline2" className="mb-2">{title}</Typography>
        <Typography variant="body" color="muted" as="p" className="mb-6">{description}</Typography>
        <Link
          href={backLink.href}
          className="inline-flex items-center px-4 py-2 bg-navigator-primary text-white rounded-lg hover:bg-navigator-primary-dark transition-colors font-medium"
        >
          {backLink.label}
        </Link>
      </div>
    </div>
  );
}
